<template>
  <div class="reg-banner-desktop">
    <img
      width="560"
      height="1028"
      src="/img/reg-auth/bonus-reg-desktop.webp"
      class="reg-banner-desktop__image"
      alt="registration banner"
    />
    <!-- <img
      v-if="srcBanner"
      :src="srcBanner"
      alt="registration banner"
      class="reg-banner-desktop__image"
    /> -->
    <div class="reg-banner-desktop__text">
      <UiText
        font="banner-kicker"
        color="banner-desktop-kicker-color"
        :text="$tc('regBanner.line1')"
      />
      <UiText
        font="banner-heading"
        color="banner-desktop-heading-color"
        :text="$tc('regBanner.line2')"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RegAuthForgotBannersDesktop',
  computed: {
    ...mapGetters('promotions', ['get_partnerBanners']),
    srcBanner() {
      const serverSrc = this.get_partnerBanners.banners?.banner_desktop

      return serverSrc ? this.$config.cloudUrl + serverSrc : null
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped></style>
